import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../../app/api/api';
import Restaurant from '../../../app/data/models/restaurant';

export interface MenuListState {
  restaurant: Restaurant | undefined;
  status: string;
}

const initialState: MenuListState = {
  restaurant: undefined,
  status: 'idle',
};

export const fetchCustomerRestaurantAsync = createAsyncThunk<
  Restaurant,
  string
>('customer/restaurant/details', async (restaurantId, thunkApi) => {
  try {
    return await api.CustomerRestaurant.details(restaurantId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    return thunkApi.rejectWithValue({ error: error.data });
  }
});

export const customerRestaurantSlice = createSlice({
  name: 'menus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCustomerRestaurantAsync.pending, (state) => {
      state.status = 'pendingFetchCustomerRestaurantDetails';
    });
    builder.addCase(fetchCustomerRestaurantAsync.fulfilled, (state, action) => {
      state.restaurant = action.payload;
      state.status = 'idle';
    });
    builder.addCase(fetchCustomerRestaurantAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});
